export default __webpack_public_path__ + "static/media/news24.1bf7a829.jpg";